import React, { memo } from "react"

// Import from the local Styles
import { Module } from "../Styles"

// Import context
import { useCaseViewContext } from '../context/CaseViewContext'

// Import real components
import { Metadata } from "./Request/Metadata"
import { Attachments } from "./Request/Attachments"
import { MIF } from "./Request/MIF"
import { Pharmacy } from "./Request/Pharmacy"
import { Eligibility } from "./Request/Eligibility"
import { PDMP } from "./Request/PDMP"
import { Treatments } from "./Request/Treatments"
import { ClinicalEvaluation } from "./Request/ClinicalEvaluation"

export const Request = memo(({ requestRef, uploadHandlers, canDeleteDocuments }) => {
    const { apiType } = useCaseViewContext()

    return (
        <Module
            width="40%"
            ref={requestRef}
        >
            <Metadata />
            {/*
            Temporarily removed until accuracy resolved
            <ClinicalEvaluation />
            */}
            <Attachments
                onFileUpload={uploadHandlers?.handleFileUpload}
                onUploadChange={uploadHandlers?.handleUploadChange}
                onBeforeUpload={uploadHandlers?.handleBeforeUpload}
                onDeleteDocument={uploadHandlers?.handleDeleteDocument}
                canDeleteDocuments={canDeleteDocuments}
            />
            <MIF/>
            <Pharmacy />
            <Eligibility />
            <PDMP />
            <Treatments apiType={apiType} />
        </Module>
    )
})
